import { Button } from '@chakra-ui/react'
import { useRouter } from 'next/router'

export default function PreviewButton() {
  const router = useRouter()

  // Check if we are in preview mode
  const inPreview = router.isPreview

  // Function to exit preview mode
  const exitPreview = async () => {
    // Make a request to your API route to exit preview mode
    await fetch('/api/exit-preview')
    // Go to the homepage
    await router.push('/')
  }

  // Only show the button if in preview mode
  if (!inPreview) {
    return null
  }

  return (
    <Button
      position="fixed"
      bottom="20px"
      right="20px"
      colorScheme="blue"
      onClick={exitPreview}
      zIndex="popover"
    >
      Exit Preview Mode
    </Button>
  )
}
